(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ProductCategoryProductDialogController', ProductCategoryProductDialogController);

    ProductCategoryProductDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ProductCategoryProduct', 'Product', 'ProductCategory'];

    function ProductCategoryProductDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ProductCategoryProduct, Product, ProductCategory) {
        var vm = this;
        vm.productCategoryProduct = entity;
        vm.products = Product.query();
        vm.productcategories = ProductCategory.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:productCategoryProductUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.productCategoryProduct.id !== null) {
                ProductCategoryProduct.update(vm.productCategoryProduct, onSaveSuccess, onSaveError);
            } else {
                ProductCategoryProduct.save(vm.productCategoryProduct, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
